{
  "components": {
    "organizationSubAudit": {
      "title": "Sub-Audits",
      "searchPlaceholder": "Find by name, number or owner..",
      "createSubAudit": "Create SubAudit",
      "subAudit": "SubAudit-{{subAuditId}}",
      "emptyListMessage": "It looks like you don't have any subAudits in this section yet.",
      "emptyListMessageWithSearch": "There are no results for the phrase you are looking for. Please use another phrase and try again",
      "sortBy": {
        "title": "Sort by:",
        "options": {
          "status": "Status"
        }
      },
      "status": {
        "new": "New",
        "info": "Gather Info - Vendor",
        "negotiation": "Negotiation in Progress",
        "negotiationComplete": "Negotiation Complete",
        "onHold": "On Hold"
      }
    },
    "subAuditForm": {
      "title": "SubAudit",
      "submitButton": {
        "create": "Create SubAudit",
        "edit": "Save"
      },
      "changeLog": {
        "subAuditCreated": {
          "subAuditWas": "SubAudit was ",
          "created": "created"
        },
        "task": {
          "created": "Task <strong>{{name}}</strong> was created by {{author}}",
          "updated": "Task <strong>{{name}}</strong> was updated by {{author}}",
          "deleted": "Task <strong>{{name}}</strong> was deleted"
        },
        "comment": {
          "added": "Comment <strong>{{name}}</strong> was added by {{author}}"
        },
        "actions": {
          "updated": "updated from",
          "changed": "changed: from {{previousValue}} to",
          "to": "to"
        },
        "fields": {
          "audit": "Audit",
          "owner": "Owner",
          "organization": "Organization",
          "vendor": "Vendor",
          "vendorAccountNumber": "Vendor Account #",
          "spendAmount": "Spend",
          "subauditStage": "SubAudit Stage",
          "updatedBy": "Updated by",
          "createdBy": "Owner",
          "teams": "Teams",
          "subauditName": "SubAudit Name",
          "location": "Location",
          "autoIncrementedId": "SubAudit ID",
          "onHold": "On Hold"
        }
      },
      "sections": {
        "details": {
          "title": "SubAudit details",
          "fields": {
            "subAuditName": {
              "label": "SubAudit Name",
              "placeholder": "SubAudit name..."
            },
            "createdDate": "Created date",
            "owner": "Owner",
            "organization": {
              "label": "Organization",
              "searchPlaceholder": "Find organization..."
            },
            "audit": {
              "label": "Audit",
              "searchPlaceholder": "Find audit..."
            },
            "vendor": {
              "label": "Vendor",
              "searchPlaceholder": "Find vendor..."
            },
            "vendorAccount": {
              "label": "Vendor Account #",
              "primary": "Primary Account #",
              "other": "Other Account #"
            },
            "spend": {
              "label": "Spend",
              "placeholder": "Spend amount..."
            },
            "team": {
              "label": "Team",
              "searchPlaceholder": "Find team..."
            },
            "localization": {
              "label": "Location",
              "searchPlaceholder": "Find location..."
            }
          }
        },
        "status": {
          "title": "Status",
          "fields": {
            "stage": {
              "label": "SubAudit Stage",
              "options": {
                "new": "New",
                "info": "Gather Info - Vendor",
                "negotiation": "Negotiation in Progress",
                "negotiationComplete": "Negotiation Complete",
                "onHold": "On Hold"
              },
              "onHoldConfirm": {
                "title": "On Hold Stage",
                "fields": {
                  "dueDate": {
                    "label": "Due date",
                    "placeholder": "Select due date..."
                  },
                  "reason": {
                    "label": "Reason",
                    "placeholder": "Reason..."
                  }
                },
                "submitButton": "Set To On Hold"
              }
            },
            "onHold": {
              "label": "(On Hold)"
            },
            "changeHistory": {
              "title": "Change history",
              "emptyMessage": "There is no change history for this SubAudit yet."
            },
            "comments": {
              "title": "Comments",
              "emptyMessage": "There are no comments yet.",
              "commentForm": {
                "title": "Add comment",
                "topic": {
                  "label": "Topic",
                  "placeholder": "Comment topic..."
                },
                "comment": {
                  "label": "Comment",
                  "placeholder": "Write a comment..."
                },
                "submitText": "Save"
              },
              "button": "Add comment"
            },
            "relatedTasks": {
              "title": "Related tasks",
              "emptyMessage": "There are no related tasks yet.",
              "button": "Create related task"
            },
            "meetingDate": "Meeting date"
          }
        }
      }
    },
    "auditDetailsHeader": {
      "title": "Edit audit",
      "breadcrumb": {
        "audits": "Audits"
      },
      "actions": {
        "createFollowUpAudit": "Create follow-up audit"
      },
      "error": {
        "title": "Failed to load audit"
      }
    },
    "auditDetails": {
      "basicInfo": {
        "spendArea": "Spend area",
        "spendCategory": "Spend category",
        "vendor": "Vendor",
        "contractTerms": "SIB Contract Terms",
        "dueDate": "Due date",
        "created": "Created",
        "creator": "Creator",
        "status": "Status"
      },
      "backfill": {
        "title": "Select audit for selected spend items",
        "columns": {
          "location": "Location",
          "vendorAccount": "Vendor Account",
          "spendItems": "Spend Items"
        },
        "spendTable": {
          "itemId": "Item ID",
          "itemName": "Item name",
          "qty": "Qty",
          "unit": "Unit",
          "cost": "Cost",
          "location": "Location",
          "reason": "Reason",
          "reasons": {
            "ambiguous_audit_match": "Ambiguous audit match",
            "no_matching_audit": "No matching audit",
            "missing_vendor_account": "Missing vendor account",
            "missing_vendor": "Missing vendor"
          },
          "emptyTitle": "No spend items",
          "emptyDescription": "Spend item details are not available yet."
        },
        "missingFields": {
          "title": "Select for missing fields",
          "vendor": "Vendor",
          "vendorContract": "Vendor Contract",
          "placeholder": "Select..."
        },
        "selectAudit": {
          "label": "Select audit",
          "placeholder": "Audit name"
        },
        "unassignableWarning": "You have spend items that cannot be assigned due to missing or incorrect data. Please contact your admin",
        "save": "Save"
      },
      "saveInfo": {
        "title": "No need to save - all changes are saved automatically"
      },
      "editForm": {
        "auditName": "Audit name",
        "status": "Status",
        "team": "Team",
        "owner": "Owner",
        "dueDate": "Due date"
      },
      "stageProgress": {
        "dialog": {
          "title": "Moving to next stage of audit",
          "description": "You are moving to the next audit stage. Once you continue, you will no longer be able to make changes to this stage. Please review all information carefully before proceeding. You will still be able to view previous stages by clicking their names.",
          "percentageFeeMissingBasis": {
            "title": "Assign spend items to Percentage Fee",
            "description": "One or more Percentage Fee items have no spend items assigned. Assign the spend items each Percentage Fee applies to before continuing."
          }
        },
        "readOnly": {
          "title": "You are viewing the {{stage}} stage in read-only mode.",
          "backToCurrent": "Back to current stage"
        }
      },
      "tabs": {
        "spendSavings": "Spend & Savings",
        "vendorContacts": "Vendor contacts",
        "managingLocations": "Managing locations",
        "documents": "Documents",
        "vendorAccount": "Vendor account",
        "vendorArchivePocs": "Vendor archive POCs",
        "linkedAudits": "Linked audits",
        "activityHistory": "Activity history",
        "comments": "Comments"
      },
      "uploadDocuments": {
        "informationMessage": "Please note that all uploaded documents will be available in the Organization’s main Documents Repository. You can attach or detach documents from an audit at any time without deleting them from the main Repository.",
        "title": "Upload or attach documents",
        "dropzoneTitle": "Drag and drop files here or use the buttons below",
        "dropzoneDescription": "Add new documents by uploading new files or attaching existing ones from the Documents Repository. All files uploaded from your computer will also be available in the Documents Repository. Supported formats: PDF, DOC, DOCX, JPG, XLSX",
        "attachFromRepository": "Attach from documents repository",
        "uploadFromComputer": "Upload from computer",
        "documentsRepository": {
          "title": "Documents repository",
          "informationMessage": "Assign documents from the Organization's Document Repository to this audit or detach them as needed. Please note that documents stored in the Organization's Document Repository cannot be edited or deleted from here. To modify a document, go to the Organization's main Document Repository.",
          "actions": {
            "attachToAudit": {
              "label": "Attach to audit",
              "ariaLabel": "Attach document to audit"
            },
            "detachFromAudit": {
              "label": "Detach from audit",
              "ariaLabel": "Detach document from this audit",
              "tooltip": "Detach document from this audit"
            },
            "displayOnlyAttached": "Display only attached documents",
            "attachedCount": "{{count}} documents attached to this audit",
            "delete": {
              "ariaLabel": "Delete document"
            },
            "attachedIndicator": {
              "ariaLabel": "Document attached to this audit",
              "tooltip": "Document attached to this audit"
            },
            "attach": {
              "success_one": "Document attached to audit successfully",
              "success_other": "{{count}} documents attached to audit successfully",
              "error": "Failed to attach document(s) to audit. Please try again."
            },
            "detach": {
              "success_one": "Document detached from audit successfully",
              "success_other": "{{count}} documents detached from audit successfully",
              "error": "Failed to detach document(s) from audit. Please try again."
            },
            "tooltips": {
              "bulkAttachDisabledAlreadyAttached": "One or more selected documents are already attached to this audit.",
              "bulkDetachDisabledNotAttached": "One or more selected documents are not attached to this audit."
            }
          },
          "table": {
            "columns": {
              "uploadedAuditStage": "Uploaded audit stage",
              "attachedToThisAudit": "Attached to this audit"
            }
          },
          "noData": {
            "title": "No documents found",
            "description": "No documents match the current filters."
          }
        }
      },
      "attachedDocuments": {
        "title": "Documents attached to this audit ({{count}})",
        "detach": "Detach",
        "detachDialog": {
          "title": "Are you sure you want to detach this document from this audit?",
          "description": "This document will no longer be associated with this audit. However, it will remain available in the organization's main Documents Repository and can be linked to audits again in the future."
        },
        "deleteDialog": {
          "title": "Are you sure you want to delete files?",
          "description": "Deleting files will also remove them from the main Documents Repository. You can attach or detach documents from an audit at any time without deleting them from the main Repository."
        },
        "actions": {
          "detach": {
            "ariaLabel": "Detach document from audit",
            "success": "Document(s) detached from audit successfully",
            "error": "Failed to detach document(s) from audit. Please try again."
          },
          "delete": {
            "ariaLabel": "Delete document",
            "success": "Document(s) deleted successfully",
            "error": "Failed to delete document(s). Please try again."
          },
          "editAriaLabel": "Edit document",
          "tooltips": {
            "bulkDetachDisabled": "Detach document(s) from this audit. They will no longer be associated with this audit but will still be available in the organization's main Documents Repository.",
            "bulkDeleteDisabled": "Delete documents. Please note deleted documents will also be removed from the organization's main Documents Repository.",
            "bulkEditUploadedDocumentsOnlyDisabled": "Bulk edit is available only for uploaded documents.",
            "bulkDeleteUploadedDocumentsOnlyDisabled": "Bulk delete is available only for uploaded documents.",
            "rowDetach": "Detach document from this audit. It will no longer be associated with this audit but will still be available in the organization's main Documents Repository.",
            "rowDelete": "Delete document. Please note deleted documents will also be removed from the organization's main Documents Repository.",
            "rowEditDisabled": "This document is attached from the main organization's Document Repository and cannot be edited here. To edit this document, please go to the main Document Repository.",
            "rowDeleteDisabled": "This document is attached from the main organization's Document Repository and cannot be deleted here. To delete this document, please go to the main Document Repository."
          }
        },
        "table": {
          "columns": {
            "annualContractValue": "Annual contract value",
            "nte": "NTE",
            "api": "API",
            "etf": "ETF",
            "startDate": "Start date",
            "endDate": "End date",
            "sensitive": "Sensitive"
          }
        },
        "noData": {
          "title": "No documents attached",
          "description": "Upload or attach documents to see them listed here."
        }
      },
      "vendorAccounts": {
        "title": "Vendor accounts",
        "description": "Enter the client's account number exactly as it appears on vendor invoices. This information is required to generate the Vendor Savings Report (VSR). Newly created vendor accounts will also be added to the organization's main vendor account list.",
        "actions": {
          "addNewAccount": "Add new account",
          "addNewAccountDisabled": "Cannot add account — audit is missing vendor or spend category.",
          "attachFromExistingList": "Attach from existing list",
          "details": "Details",
          "detailsTooltip": "This vendor account was attached from the organization's main Vendor Accounts list and cannot be edited here. You can still view its details. To edit this account, please go to the main Vendor Accounts list.",
          "edit": "Edit",
          "detach": "Detach",
          "detachTooltip": "Detach this vendor account from the audit. It will no longer be associated with this audit but will remain available in the organization's main Vendor Accounts list."
        },
        "form": {
          "addTitle": "Add new vendor account",
          "editTitle": "Edit vendor account",
          "detailsTitle": "Vendor account details",
          "infoBanner": "Please note that newly created vendor accounts will be tied to audit's selected vendor and spend category and will be also automatically created in organization's main vendor account list. The account number status is set to Active by default. You can change it later by editing the vendor account.",
          "accountNumberHelper": "Required for VSR",
          "vendorTooltip": "You cannot edit the vendor for this vendor account. It is automatically assigned from the audit.",
          "spendCategoriesTooltip": "Spend categories are inherited from the audit vendor and cannot be changed here.",
          "notifications": {
            "createSuccess": "Vendor account created and attached to audit successfully",
            "createError": "Failed to create vendor account",
            "attachError": "Vendor account was created but failed to attach to audit. You can attach it from the existing list.",
            "updateSuccess": "Vendor account updated successfully",
            "updateError": "Failed to update vendor account"
          }
        },
        "emptyState": {
          "title": "No vendor accounts assigned or created yet",
          "description": "Add a new vendor account or attach one from the organization's existing vendor account list"
        },
        "fields": {
          "accountNumber": "Account number",
          "accountName": "Account name",
          "vendor": "Vendor",
          "status": "Status",
          "spendCategories": "Spend categories ({{count}})",
          "locations": "Locations",
          "notes": "Notes"
        },
        "detachDialog": {
          "title": "Are you sure you want to detach this vendor account from this audit?",
          "description": "This vendor account will no longer be associated with this audit. However, it will remain available in the organization's main vendor account list and can be linked to audits again in the future."
        },
        "statusChangeDialog": {
          "activate": {
            "title": "Activating vendor account",
            "description": "You've changed the status of the vendor account to Active. Are you sure you want to activate this vendor account?",
            "confirm": "Activate"
          },
          "deactivate": {
            "title": "Deactivating vendor account",
            "description": "You've changed the status of the vendor account to Inactive. Are you sure you want to deactivate this vendor account?",
            "confirm": "Deactivate"
          }
        },
        "duplicatesDialog": {
          "title_one": "A matching vendor account already exists",
          "title_other": "Matching vendor accounts already exist",
          "description_one": "A vendor account with the same vendor and locations already exists. Use it instead of creating a duplicate, or create the new account anyway.",
          "description_other": "{{count}} vendor accounts with the same vendor and locations already exist. Use one of them instead of creating a duplicate, or create the new account anyway.",
          "exactMatchDescription": "A vendor account with this account number already exists for this vendor. Use the existing account instead.",
          "noLocations": "No locations",
          "createAnyway": "Create anyway",
          "open": "Open",
          "alreadyAttached": "Already attached",
          "checkError": "Failed to check for existing vendor accounts. Please try again."
        },
        "detach": {
          "success": "Vendor account(s) detached from audit successfully",
          "error": "Failed to detach vendor account(s) from audit. Please try again."
        },
        "repository": {
          "title": "Vendor accounts",
          "informationMessage": "You are currently viewing only vendor accounts associated with this audit's vendor and spend category (Spend Category: <strong>{{spendCategoryName}}</strong>). To see all vendor accounts, go to the organization's Vendor Accounts list.",
          "informationMessageWithVendor": "You are currently viewing only vendor accounts associated with this audit's vendor and spend category (Vendor: <strong>{{vendorName}}</strong> & Spend Category: <strong>{{spendCategoryName}}</strong>). To see all vendor accounts, go to the organization's Vendor Accounts list.",
          "actions": {
            "attachToAudit": {
              "label": "Attach to audit",
              "ariaLabel": "Attach vendor account to audit"
            },
            "detachFromAudit": {
              "label": "Detach from audit",
              "ariaLabel": "Detach vendor account from this audit",
              "tooltip": "Detach vendor account from this audit"
            },
            "displayOnlyAttached": "Display only attached accounts",
            "attachedCount": "{{count}} vendor accounts attached to this audit",
            "attachedIndicator": {
              "ariaLabel": "Vendor account attached to this audit",
              "tooltip": "Vendor account attached to this audit"
            },
            "attach": {
              "success_one": "Vendor account attached to audit successfully",
              "success_other": "{{count}} vendor accounts attached to audit successfully",
              "error": "Failed to attach vendor account(s) to audit. Please try again."
            },
            "detach": {
              "success_one": "Vendor account detached from audit successfully",
              "success_other": "{{count}} vendor accounts detached from audit successfully",
              "error": "Failed to detach vendor account(s) from audit. Please try again."
            },
            "tooltips": {
              "bulkAttachDisabledAlreadyAttached": "One or more selected vendor accounts are already attached to this audit.",
              "bulkDetachDisabledNotAttached": "One or more selected vendor accounts are not attached to this audit."
            }
          },
          "table": {
            "columns": {
              "vendorAccountName": "Vendor account name",
              "assignedAudits": "Assigned audits"
            }
          },
          "noData": {
            "title": "No vendor accounts found",
            "description": "No vendor accounts match the current filters."
          }
        }
      },
      "comments": {
        "title": "Comments ({{count}})",
        "description": "Add comments to this audit about topics you would like other SIB employees to be aware of, such as important decisions or unusual circumstances.",
        "actions": {
          "addNew": "Add new"
        },
        "emptyState": {
          "title": "It looks like there are no comments added for this audit yet",
          "description": "Create your first comment by clicking \"Add new\" button"
        },
        "filters": {
          "search": "Search",
          "creator": "Creator",
          "created": "Created",
          "createdInAuditStage": "Created in audit stage"
        },
        "tile": {
          "subject": "Subject",
          "creator": "Creator",
          "created": "Created",
          "createdInAuditStage": "Created in audit stage",
          "commentNote": "Comment",
          "delete": "Delete",
          "deleteDisabledTooltip": "You can only delete comments you created",
          "seeMore": "see more",
          "seeLess": "see less"
        },
        "deleteDialog": {
          "title": "Delete comment",
          "description": "Are you sure you want to delete this comment? This action cannot be undone."
        },
        "notifications": {
          "deleteSuccess": "Comment deleted successfully",
          "deleteError": "Failed to delete comment"
        },
        "form": {
          "title": "Add new comment",
          "fields": {
            "subject": "Subject",
            "commentNote": "Comment"
          },
          "notifications": {
            "createSuccess": "Comment created successfully",
            "createError": "Failed to create comment"
          }
        }
      },
      "spendEstimated": {
        "title": "Import spend items",
        "description": "Import spend items from a template, create them manually, or use spend items from an existing audit.",
        "actions": {
          "addSpend": "Add item",
          "addSpendFixedFee": "Fixed Fee",
          "addSpendPercentageFee": "Percentage Fee",
          "addSpendPercentageFeeDisabledTooltip": "Add at least one spend item before using Percentage Fee.",
          "addSpendUsageFee": "Usage Fee",
          "downloadTemplate": "Template",
          "uploadSpend": "Import items",
          "attachFromExistingAudit": "Attach spend items from existing audit"
        },
        "upload": {
          "dialogTitle": "Upload spend estimated file",
          "fileLabel": "Spend estimated file",
          "success": "Spends imported successfully",
          "invalidRows": "{{count}} row(s) failed validation. Please fix the file and try again.",
          "duplicatesSkipped": "{{count}} duplicate spend item(s) were skipped.",
          "missingLocationInfo": "Some imported rows are missing a location number. You can add locations later.",
          "confirmError": "Failed to import spend items. Please try again."
        },
        "invalidImportDialog": {
          "title": "Some records have incorrect fields",
          "description": "{{incorrect}} out of {{total}} rows need attention before import. Fix the highlighted fields or remove the row.",
          "editIncorrectFields": "Edit incorrect fields",
          "requiredFieldsTooltip": "Please fill in all required fields before confirming the import"
        },
        "invalidImportTable": {
          "columns": {
            "vendorAccountNumber": "Vendor Account Number",
            "name": "Name",
            "pricingModel": "Pricing Model",
            "unit": "Unit",
            "quantity": "Quantity",
            "pricePerUnit": "Price Per Unit",
            "type": "Occurrence Type",
            "frequency": "Occurrence Frequency",
            "locationId": "Location Identifier",
            "remove": "Remove"
          }
        },
        "totals": {
          "auditTotal": "Total"
        },
        "locationGroups": {
          "organizationWide": "Organization-wide"
        },
        "spend": {
          "edit": "Edit spend",
          "delete": "Delete spend",
          "form": {
            "titleCreateFixedFee": "Add Spend Item (Fixed Fee)",
            "titleCreatePercentageFee": "Add Spend Item (Percentage Fee)",
            "titleCreateUsageFee": "Add Spend Item (Usage Fee)",
            "titleEdit": "Edit item",
            "successCreate": "Spend created successfully",
            "successEdit": "Spend updated successfully",
            "successBulkEdit": "Spends updated successfully",
            "errorBulkEdit": "Failed to update selected spends",
            "commonFields": "Common Fields",
            "fixedFeeFields": "Fixed Fee Fields",
            "percentageFeeFields": "Percentage Fee Fields",
            "usageFeeFields": "Usage Fee Fields",
            "tooltips": {
              "vendorAccount": "Select a vendor account first",
              "location": "Select a specific location first",
              "frequencyOneTime": "Frequency applies only to recurring spend items",
              "lockedPricingModel": "Not available for {{model}} spend items. The pricing model can't be changed."
            },
            "fields": {
              "name": "Spend Item Name",
              "vendorAccountNumber": "Vendor account number",
              "unit": "Unit",
              "quantity": "Quantity",
              "pricePerUnit": "Price per unit",
              "type": "Type",
              "frequency": "Frequency",
              "location": "Location",
              "locationHelper": "Leave as organization-wide when the spend applies to the whole organization.",
              "indexRate": "Index Rate",
              "quantityType": "Quantity Type",
              "tierType": "Tier Type",
              "tierValue": "Tier Value",
              "taxable": "Taxable",
              "unitCost": "Unit Cost",
              "baseSpendItems": "Base Spend Items",
              "percentageAutoCalculatedNote": "Auto-calculated subtotal: set base item and percentage above",
              "percentageAutoCalculatedSubtotal": "Auto-calculated subtotal: {{amount}}",
              "percentage": "Percentage (%)",
              "minimumFee": "Minimum Fee",
              "minimumFeeNote": "Minimum Fee Note"
            }
          },
          "deleteDialog": {
            "title": "Delete spend",
            "bulkTitle": "Delete spends",
            "description": "This will permanently remove this spend from the audit.",
            "bulkDescription": "This will permanently remove {{count}} spends from the audit.",
            "success_one": "Spend deleted successfully",
            "success_other": "{{count}} spends deleted successfully"
          }
        },
        "table": {
          "columns": {
            "name": "Name",
            "vendorAccountNumber": "Vendor account number",
            "model": "Model",
            "taxable": "Taxable",
            "unit": "Unit",
            "quantity": "Qty",
            "keyRatePrice": "Key Rate / Price",
            "pricePerUnit": "Cost",
            "total": "Cost",
            "type": "Type",
            "frequency": "Frequency",
            "indexRate": "Index Rate",
            "quantityType": "Quantity Type",
            "tierType": "Tier Type",
            "tierValue": "Tier Value",
            "minimumFee": "Minimum Fee",
            "minimumFeeNote": "Minimum Fee Note",
            "locationName": "Location",
            "notes": "Notes"
          }
        },
        "notesDialog": {
          "title": "Spend item – notes",
          "notesTitle": "Notes ({{count}})",
          "addButton": "Add note",
          "deleteLabel": "Delete note",
          "deleteDisabledTooltip": "You cannot delete this note because it was not created by you",
          "deleteDialog": {
            "title": "Deleting note",
            "description": "Are you sure you want to delete this note?"
          },
          "info": {
            "itemName": "Item name",
            "location": "Location",
            "ava": "AVA",
            "type": "Type",
            "frequency": "Frequency"
          }
        },
        "emptyState": {
          "title": "No spends imported yet",
          "description": "Download the template, fill it with spend data, and upload it to view estimated spend for this audit."
        }
      },
      "percentageBasis": {
        "highlighting": "Highlighting:",
        "clearHighlight": "Clear highlight",
        "column": "Based on",
        "sides": {
          "baseline": {
            "title": "Baseline",
            "heading": "Baseline ({{count}})",
            "count_one": "{{count}} baseline",
            "count_other": "{{count}} baseline"
          },
          "proposed": {
            "title": "Proposed",
            "heading": "Proposed ({{count}})",
            "count_one": "{{count}} proposed",
            "count_other": "{{count}} proposed"
          }
        },
        "tooltip": {
          "more": "+{{count}} more",
          "empty": "No items yet."
        },
        "dialog": {
          "title": "Based on — {{name}}",
          "description": "Manage which spend items this fee is calculated from.",
          "descriptionSplit": "Manage which spend items this fee is calculated from, split by stage.",
          "add": "Add",
          "selectItemToAdd": "Select item to add",
          "searchPlaceholder": "Search items...",
          "noCandidates": "No more items to add",
          "requirements": {
            "vendorAccount": "Set a vendor account on this fee to add items.",
            "location": "Set a specific location on this fee to add items."
          },
          "empty": "This fee isn't based on any items yet.",
          "removeItem": "Remove {{name}}",
          "assignedTotal_one": "{{count}} item assigned total",
          "assignedTotal_other": "{{count}} items assigned total",
          "save": "Save changes",
          "success": "Fee basis updated successfully"
        },
        "grouping": {
          "toggle": "Group by % Fee",
          "feeWithRate_one": "{{name}} ({{rate}}%) — {{count}} base item",
          "feeWithRate_other": "{{name}} ({{rate}}%) — {{count}} base items",
          "fee_one": "{{name}} — {{count}} base item",
          "fee_other": "{{name}} — {{count}} base items",
          "unassigned": "Unassigned items ({{count}})",
          "continued": "(continued)",
          "partialData": "The grouped view shows the first {{count}} items."
        },
        "legend": {
          "sides": {
            "baseline": "Baseline group",
            "proposed": "Proposed group"
          },
          "hoverModel": "Hover “Model” on % fee rows to preview",
          "clickBasedOn": "Click “Based on” tags to open the editor",
          "clickFeeRow": "Click a % fee row to highlight its base items"
        }
      },
      "initialValidation": {
        "invoices": {
          "savingsStartDate": "Savings start date",
          "savingsStartDateTooltip": "The date savings tracking begins for this audit.",
          "listTitle": "Vendor invoices",
          "uploadedCount_one": "{{count}} uploaded invoice",
          "uploadedCount_other": "{{count}} uploaded invoices",
          "edit": "Edit invoice",
          "download": "Download invoice",
          "uploadFile": {
            "action": "Upload file",
            "success": "File uploaded successfully"
          },
          "delete": "Delete invoice",
          "detach": "Detach from audit",
          "selectAll": "Select all invoices",
          "selectRow": "Select invoice",
          "filters": {
            "issueDate": "Issue date"
          },
          "actions": {
            "downloadZip": "Download .ZIP",
            "addInvoice": "Bill stream"
          },
          "badges": {
            "monitoringSavings": "MS",
            "internalOnly": "Internal only"
          },
          "attachFromRepositoryModal": {
            "title": "Attach from documents repository",
            "informationMessage": "Choose a document from the organization repository to attach as an invoice for this audit.",
            "actions": {
              "attachedCount": "{{count}} documents already attached as invoices on this audit",
              "rowAttach": {
                "ariaLabel": "Attach document as invoice"
              },
              "attachedIndicator": {
                "ariaLabel": "Document already attached as invoice",
                "tooltip": "This document is already attached as an invoice on this audit"
              }
            }
          },
          "updateStatusSuccess": "Invoice status updated successfully",
          "status": {
            "draft": "Draft",
            "notCollected": "Not collected",
            "review": "Invoice received – reviewing",
            "vendorCorrection": "Sent back for vendor correction",
            "confirmed": "Confirmed",
            "approved": "Confirmed – savings realized",
            "superseded": "Superseded"
          },
          "form": {
            "titleCreate": "Upload new invoice",
            "titleEdit": "Edit invoice",
            "successCreate": "Invoice uploaded successfully",
            "successEdit": "Invoice updated successfully",
            "titleIssueDateOnly": "Add invoice by issue date",
            "titleAttachFromRepository": "Attach document as invoice",
            "successCreateIssueDateOnly": "Invoice added successfully",
            "successCreateFromRepository": "Invoice created from document successfully",
            "repositoryDocumentHint": "From the organization documents repository",
            "fields": {
              "file": "Invoice file",
              "issueDate": "Issue date",
              "internal": "Internal only",
              "invoiceTemplate": "Bill stream",
              "invoiceTemplateHelper": "Pick the stream this bill belongs to, or leave empty to open a new one.",
              "invoiceTemplateHelperExistingOnly": "Pick the existing stream this bill belongs to.",
              "invoiceTemplatePlaceholder": "New bill stream",
              "invoiceTemplatePlaceholderExistingOnly": "Select bill stream",
              "vendorAccount": "Affected Vendor Account",
              "billingInterval": "Billing interval",
              "location": "Location",
              "spendCategory": "Spend category",
              "repositoryDocument": "Document"
            },
            "errors": {
              "issueDateOutsideRange": "Issue date must fall inside the selected period.",
              "invoiceTemplateRequired": "Pick an existing bill stream."
            }
          },
          "deleteDialog": {
            "title": "Deleting invoice",
            "description": "Are you sure you want to delete this invoice? Please review any validated items first, as they may have been validated based on this invoice.",
            "success": "Invoice deleted successfully"
          },
          "fields": {
            "name": "Name",
            "fileName": "Invoice (file) name",
            "uploadDate": "Upload date",
            "issueDate": "Issue date",
            "ava": "AVA",
            "locations": "Locations",
            "status": "Status"
          },
          "details": {
            "title": "Invoice details",
            "vendorAccounts": {
              "label": "Assign Affected Vendor Accounts",
              "helper": "Please note that you can only assign locations linked to selected vendor accounts. If you change the vendor accounts, you'll need to review and assign the locations once again."
            },
            "locations": {
              "labelWithCount": "Assigned locations ({{assigned}}/{{available}})",
              "tooltip": "You can only assign locations linked to the selected vendor accounts. Select and save vendor account first.",
              "manage": "Manage assigned locations"
            },
            "viewer": {
              "emptyState": {
                "title": "No file preview available"
              }
            },
            "spendBrainVisibility": {
              "checkboxLabel": "Display this invoice in the client's SpendBrain",
              "publishedBanner": "This invoice is published to the client's SpendBrain. Clients with access can view it in their documents.",
              "disabledNoDocument": "Attach a bill file before you can publish this invoice to SpendBrain."
            }
          },
          "emptyState": {
            "title": "No invoices uploaded yet",
            "description": "Upload a vendor invoice to start validating spend items for this audit."
          },
          "locationsModal": {
            "titleView": "Locations linked to this invoice",
            "titleManage": "Assigning locations to invoice",
            "manageAssignedLocations": "Manage assigned locations",
            "informationMessage": "Please note that you can only assign locations linked to this vendor account. If you change the vendor account, you’ll need to assign the locations again.",
            "affectedVendorAccounts": "Affected Vendor Accounts",
            "actions": {
              "attachToInvoice": {
                "label": "Attach to invoice",
                "ariaLabel": "Attach location to invoice"
              },
              "detachFromInvoice": {
                "label": "Detach from invoice",
                "ariaLabel": "Detach location from this invoice",
                "tooltip": "Detach location from this invoice"
              },
              "displayOnlyNotAttached": "Display only not attached locations",
              "attachedCount": "{{count}}/{{total}} locations attached to this invoice",
              "attachedIndicator": {
                "ariaLabel": "Location attached to this invoice",
                "tooltip": "Location attached to this invoice"
              },
              "attach": {
                "success_one": "Location attached to invoice successfully",
                "success_other": "{{count}} locations attached to invoice successfully",
                "error": "Failed to attach location(s) to invoice. Please try again."
              },
              "detach": {
                "success_one": "Location detached from invoice successfully",
                "success_other": "{{count}} locations detached from invoice successfully",
                "error": "Failed to detach location(s) from invoice. Please try again."
              },
              "tooltips": {
                "bulkAttachDisabledAlreadyAttached": "One or more selected locations are already attached to this invoice.",
                "bulkDetachDisabledNotAttached": "One or more selected locations are not attached to this invoice."
              }
            },
            "noData": {
              "title": "No locations found",
              "description": "No locations match the current filters."
            }
          },
          "stageCopy": {
            "initialValidation": {
              "title": "Vendor invoices & savings start date",
              "description": "Upload invoices to validate spend items. Remember to link invoices to the relevant vendor accounts and the locations assigned to those vendor accounts. If not all items on an invoice can be validated, you can mark the invoice to be deployed in the next stage, Monitoring savings. This will make it easier to continue working on and monitoring the relevant spend items."
            },
            "monitoringSavings": {
              "title": "Vendor invoices",
              "description": "Upload invoices to validate spend items or spend item groups for the selected period. Remember to link invoices to the relevant vendor accounts and the locations assigned to those vendor accounts. Bills attached during Initial validation are listed here as well and can still be previewed."
            }
          },
          "templates": {
            "label": "Bill stream",
            "billingInterval": "Billing interval",
            "billingIntervalTooltip": "How often this stream issues a bill. Monitoring savings uses it to show the expected bills before they arrive.",
            "bills": "Bills",
            "noBills": "No bills on this stream in the selected period.",
            "actions": {
              "showBills": "Show bills",
              "hideBills": "Hide bills",
              "addBill": "Add bill"
            },
            "editDialog": {
              "title": "Edit bill stream",
              "description": "Pick the vendor accounts this stream is billed on and the locations they serve. Changing an account detaches a location it no longer serves.",
              "success": "Bill stream updated successfully"
            },
            "locationsModal": {
              "title": "Assigning locations to bill stream",
              "informationMessage": "Please note that you can only assign locations linked to the selected vendor accounts. If you change the vendor accounts, you'll need to assign the locations again."
            },
            "existingStreamDialog": {
              "title": "Bill stream already exists",
              "description": "A bill stream for the selected vendor account and locations already exists. The bill will be added to it, and the bill stream will appear in this audit.",
              "similarTitle": "Similar bill streams already exist",
              "similarDescription": "These bill streams share vendor accounts and locations with your selection. You can still create a new bill stream.",
              "confirm": "Add to bill stream",
              "createNew": "Create new bill stream",
              "preview": "Preview",
              "previewTitle": "Latest bill",
              "vendorAccounts": "Vendor accounts",
              "locations": "Locations",
              "noLocations": "No locations"
            }
          },
          "manual": {
            "keyedIn": "Keyed-in bill (no file)",
            "badge": "No file yet",
            "uploadFile": "Attach the bill file",
            "uploadSuccess": "Bill file attached successfully",
            "selectDisabledNoDocument": "Attach a bill file before you can select this invoice for download.",
            "attachOptions": {
              "repository": "From docs repo",
              "file": "From computer"
            }
          },
          "attachDetailsDialog": {
            "confirm": "Attach"
          },
          "addDialog": {
            "title": "Bill stream",
            "description": "Choose how the invoice gets onto the bill stream.",
            "options": {
              "issueDate": {
                "title": "Issue date only",
                "description": "The invoice has not been collected yet. Record its issue date now and attach the file later."
              },
              "repository": {
                "title": "Attach from documents repository",
                "description": "Pick a document already uploaded to the organization repository."
              },
              "file": {
                "title": "Upload a new file",
                "description": "Upload the invoice file from your computer."
              }
            }
          }
        },
        "spendItems": {
          "title": "Validate spend items",
          "description": "Check whether the proposed spend for the item matches the actual spend reported on the vendor's invoice.",
          "displayNotValidatedOnly": "Display not validated only",
          "displayByLocation": "Display by location & AVA",
          "displayBySpendItem": "Display by spend item",
          "addSpend": "Add item",
          "validate": "Validate",
          "markAsNotValidated": "Mark as not validated",
          "validateTooltip": "Mark the spend item as validated once the invoice values have been checked against the approved spend.",
          "validateDisabledNoInvoice": "Please add invoice first",
          "validateDisabledNoInvoiceTemplate": "Please link a bill stream first",
          "validateDisabledNoValidatedItems": "Validate at least one item first",
          "validateDisabledAlreadyValidated": "Validated groups cannot be un-validated",
          "bulkMarkAsNotValidated": {
            "success_one": "Spend item marked as not validated",
            "success_other": "{{count}} spend items marked as not validated"
          },
          "savingsStartDateTooltip": "Date when savings for this spend item start being realized.",
          "savingsEndDateTooltip": "Date when savings for this spend item stop being realized.",
          "validatedEditDisabledTooltip": "You cannot edit validated items. Mark as not validated first to make changes.",
          "validatedQuantityNotApplicableTooltip": "Quantity does not apply to a percentage fee spend.",
          "validatedUnitNotApplicableTooltip": "Unit does not apply to a percentage fee spend.",
          "validateDialog": {
            "title": "Validate spend item",
            "description": "You are validating a spend item. Are you sure you want to proceed?",
            "hint": "Validation will automatically set the savings start date to today if no date has been selected. You can always change it manually later."
          },
          "validateSuccess": "Spend item validated",
          "markAsNotValidatedSuccess": "Spend item marked as not validated",
          "bulkValidateSuccess": "{{count}} spend item(s) validated",
          "bulkMarkAsNotValidatedSuccess": "{{count}} spend item(s) marked as not validated",
          "setStatusSuccess": "Status updated",
          "updateValidatedSpendSuccess": "Validated spend updated",
          "setSavingsDatesSuccess": "Savings dates updated",
          "filters": {
            "location": "Location",
            "affectedVendorAccount": "Affected Vendor Account"
          },
          "locationAvaGroup": {
            "label": "Location & AVA group",
            "avaLabel": "{{ava}} ({{avaName}})",
            "showItems": "Show items",
            "hideItems": "Hide items",
            "showAllItems": "Show all items",
            "hideAllItems": "Hide all items",
            "baselineSpend": "Baseline spend",
            "validatedSpend": "Validated spend",
            "savings": "Savings",
            "validatedCount": "{{validated}} / {{total}} validated",
            "addItem": "Add item",
            "validateSuccess": "Location group validated",
            "markAsNotValidatedSuccess": "Location group marked as not validated",
            "invoiceTemplate": {
              "label": "Bill stream",
              "placeholder": "Select bill stream",
              "linkSuccess": "Bill stream linked",
              "relinkTitle": "Change bill stream?",
              "relinkDescription": "Items validated in initial validation become invoiceless and every other spend line and period of this group on the current bill stream is deleted. This cannot be undone.",
              "relinkValidatedDescription": "This group is already validated. Its validation will be cleared and all of its monitoring savings lines on the current bill stream will be lost."
            }
          },
          "columns": {
            "itemId": "Item ID",
            "itemName": "Item name",
            "location": "Location",
            "ava": "AVA",
            "avaName": "AVA name",
            "baselineSpend": "Baseline spend",
            "baselineSpendPerItem": "Baseline spend per item",
            "approved": "Approved",
            "validatedGroup": "Validated",
            "costPerItem": "Cost / item",
            "quantity": "Qty",
            "unit": "Unit",
            "freq": "Freq",
            "spend": "Spend",
            "variance": "Variance",
            "status": "Status",
            "type": "Type",
            "savingsStartDate": "Savings start date",
            "savingsEndDate": "Savings end date",
            "notes": "Notes",
            "validated": "Validated",
            "hidden": "Hidden",
            "excludedFromSavings": "Excl. savings",
            "invoice": "Bill",
            "model": "Model",
            "taxable": "Taxable",
            "indexRate": "Index Rate",
            "quantityType": "Quantity Type",
            "tierType": "Tier Type",
            "tierValue": "Tier Value",
            "minimumFee": "Minimum Fee",
            "minimumFeeNote": "Minimum Fee Note"
          },
          "status": {
            "match": "Match",
            "mismatch": "Mismatch",
            "pending": "Pending"
          },
          "baselineHistory": {
            "title": "Baseline spend history",
            "open": "View baseline spend history",
            "unavailable": "Baseline spend history is unavailable right now.",
            "effectiveFrom": "Effective from",
            "pricePerUnit": "Cost / item",
            "percentageRate": "Percentage rate",
            "sourceLabel": "Source",
            "note": "Note",
            "currentValue": "Current",
            "addedBy": "Added by {{name}} on {{date}}",
            "addValue": "Add value",
            "addValueTitle": "Key in a new rate",
            "addValueSuccess": "Baseline rate added",
            "noteRequiredWhenChanged": "A note is required when the cost / item changes",
            "noteRequiredWhenPercentageChanged": "A note is required when the percentage rate changes",
            "source": {
              "manual": "Manual",
              "formula": "Formula",
              "sync": "Sync"
            }
          },
          "notesDialog": {
            "title": "Spend item – notes",
            "notesTitle": "Notes ({{count}})",
            "addButton": "Add note",
            "deleteLabel": "Delete note",
            "deleteDisabledTooltip": "You cannot delete this note because it was not created by you",
            "deleteDialog": {
              "title": "Deleting note",
              "description": "Are you sure you want to delete this note?"
            },
            "groupUnavailable": "Group notes are unavailable because this location group has not been synced with the server yet.",
            "info": {
              "itemId": "Item ID",
              "itemName": "Item name",
              "location": "Location",
              "ava": "AVA",
              "avaName": "AVA name",
              "type": "Type",
              "frequency": "Frequency"
            }
          },
          "validateLocationGroupDialog": {
            "title": "Validate a location group with some unvalidated spend items ({{unvalidated}} / {{total}})",
            "titleWithMissingNotes": "Validate a location group with some unvalidated spend items ({{unvalidated}}/{{total}}), one of which has no notes ({{withoutNotes}}/{{total}})",
            "confirmTitle": "Validate location group",
            "spendItemsLabel": "Spend items",
            "description": {
              "review": "You are trying to validate a location group with some of the spend items that have not been validated ({{unvalidated}}/{{total}}). Please review the notes attached to those items and, if necessary, add new notes.",
              "reviewMissingNotes": "You are trying to validate a location group with some of the spend items that have not been validated ({{unvalidated}}/{{total}}), and {{withoutNotes}}/{{total}} of them have no notes. Please add a description to unvalidated items without notes and review the notes attached to those items.",
              "monitoringSavings": "Once you validate a location group, it will appear with all of its spend items in the \"Monitoring Savings\" stage. You can no longer edit it in the \"Initial Validation\" stage. However, you can make some changes in \"Monitoring Savings\". You can easily switch between the two stages.",
              "savingsStartDate": "Validating the group will automatically set the savings start date to today if no date has been selected for a specific spend item."
            },
            "confirmation": "Are you sure you want to proceed?",
            "showNotes": "Show notes",
            "hideNotes": "Hide notes",
            "noNotes": "There are no notes for this spend item.",
            "notesTitle": "Notes",
            "validatedSpend": "Validated spend"
          },
          "locationGroupNotesDialog": {
            "title": "Location group – notes",
            "showSpendItems": "Show spend items in this group",
            "spendItems": "Spend items",
            "validatedSpend": "Validated spend",
            "showNotes": "Show notes",
            "hideNotes": "Hide notes"
          },
          "emptyState": {
            "title": "No spend items",
            "description": "There are no spend items to validate yet."
          },
          "invoice": {
            "placeholder": "Select a bill",
            "empty": "No bills on this validation group yet",
            "noFile": "Keyed in, no file",
            "attachSuccess": "Bill attached to the spend item",
            "tooltip": "The bill this spend item is validated against. Required before validating."
          }
        }
      },
      "monitoringSavings": {
        "title": "Monitoring Savings",
        "description": "Monitor spend items and invoices for this audit, continue the approval and validation processes started in the Initial Validation stage, and prepare the data entry needed to build the VSR report. You can also display all data for all months covered by the audit.",
        "dateRange": {
          "title": "Date range & filtering",
          "description": "Select a date range to display invoices and spend item groups. By default, the current month is displayed. You can also filter spend item groups by locations and Affected Vendor Accounts.",
          "label": "Date range",
          "currentMonth": "current mo"
        },
        "groups": {
          "title": "Monitor and continue validating spend item groups.",
          "description": "Monitor spend items and spend item groups for this audit, continue the validation processes started in the Initial Validation stage, and prepare the data entry needed to build the VSR report. Please note that you're validating spend item groups and spend items per expected bill.",
          "emptyState": "No location & AVA groups match the current filters."
        },
        "periods": {
          "expectedBill": "Expected bill",
          "noPeriods": "No expected bills for this group in the selected period. Set the billing interval on the group's bill stream and upload its first bill to see the expected slots.",
          "notesTitle": "Bill period {{date}} – notes",
          "validateSuccess": "Period validated",
          "markAsNotValidatedSuccess": "Period marked as not validated"
        },
        "rounds": {
          "validateTooltip": "Mark the spend item as validated for this bill once the invoice values have been checked against the approved spend.",
          "emptyState": {
            "description": "There are no spend items for this bill."
          },
          "noAuditForNotes": "This spend item is not part of an audit, so it cannot hold notes.",
          "hiddenTooltip": "This spend item does not appear on this bill. Hidden rounds are left out of savings entirely.",
          "hiddenRowDisabledTooltip": "This spend item is hidden on this bill. Turn off Hidden to edit it again.",
          "excludedFromSavingsTooltip": "This spend item appears on the bill, but the client is not billed for it.",
          "setHiddenSuccess": "Spend item hidden on this bill",
          "unsetHiddenSuccess": "Spend item shown on this bill",
          "setExcludedFromSavingsSuccess": "Spend item excluded from savings",
          "unsetExcludedFromSavingsSuccess": "Spend item included in savings"
        }
      },
      "spendItems": {
        "occurrenceType": {
          "one_time": "One-time",
          "recurring": "Recurring"
        },
        "occurrenceFrequency": {
          "monthly": "Monthly",
          "quarterly": "Quarterly",
          "yearly": "Yearly"
        },
        "quantityType": {
          "estimate": "Estimate",
          "average": "Average",
          "actual": "Actual"
        },
        "tierType": {
          "volume": "Volume",
          "usage_band": "Usage Band",
          "discount_tier": "Discount Tier"
        },
        "pricingModel": {
          "fixed_fee": "Fixed Fee",
          "percentage_rate": "Percentage Fee",
          "usage_based": "Usage Fee"
        }
      },
      "negotiations": {
        "kpis": {
          "baselineSpend": "Baseline spend",
          "proposedSpend": "Proposed spend",
          "savingsIdentified": "Savings identified",
          "spendItemsCount": "No of spend items",
          "lockedAtAuditLevel": "locked at audit level",
          "savingsPercentage": "({{percentage}} %)"
        },
        "continueDialog": {
          "notApproved": {
            "title": "Some of items are not approved",
            "description": "Only {{approved}} out of {{total}} spend items are approved. {{rejected}} items will be marked as rejected and cannot be approved later on. Are you sure you want to move to the next audit stage? Once completing this step you can display it only."
          },
          "missingSpend": {
            "title": "Some items do not have a proposed spend value assigned",
            "description": "They will be marked as approved but will show 0% savings in subsequent stages."
          },
          "negativeSavings": {
            "title": "Negative savings detected",
            "description": "For some items, the proposed spend is higher than the baseline spend, which means the savings will be negative."
          },
          "notApprovedAndMissing": {
            "title": "Some of items are not approved or do not have a proposed spend value assigned",
            "description": "Only {{approved}} out of {{total}} spend items are approved and {{missing}} of them has no proposed spend value assigned. {{rejected}} items will be marked as rejected and cannot be approved later on. Are you sure you want to move to the next audit stage? Once completing this step you can display it only."
          },
          "notApprovedAndNegative": {
            "title": "Some of items are not approved or has negative spend detected",
            "description": "Only {{approved}} out of {{total}} spend items are approved. {{rejected}} items will be marked as rejected and cannot be approved later on. Are you sure you want to move to the next audit stage? Once completing this step you can display it only."
          },
          "missingAndNegative": {
            "title": "Some items do not have a proposed spend value assigned or has negative spend detected",
            "description": "They will be marked as approved but will show 0% savings in subsequent stages. For some items, the proposed spend is higher than the baseline spend, which means the savings will be negative."
          },
          "all": {
            "title": "Some of items are not approved, do not have a proposed spend value assigned or has negative spend detected",
            "description": "Only {{approved}} out of {{total}} spend items are approved and {{missing}} of them has no proposed spend value assigned. {{rejected}} items will be marked as rejected and cannot be approved later on. Are you sure you want to move to the next audit stage? Once completing this step you can display it only."
          },
          "approvedSpendItemsLabel": "No of approved spend items",
          "approvedWithoutProposedSpendLabel": "No of approved items without any proposed spend assigned",
          "itemsWithoutProposedSpendLabel": "No of items you want to approve without any proposed spend assigned",
          "negativeSavingsItemsLabel": "No of spend items with negative savings detected",
          "savingsPercentage": "{{percentage}} % savings"
        },
        "vendors": {
          "title": "Vendor",
          "description": "At this stage, you are negotiating the spend with the vendor. If the baseline vendor does not meet your expectations, you can attach another existing vendor to the audit and negotiate a better proposed spend with them. If you attach a vendor, don't forget to assign them to the items being negotiated.",
          "baselineSpendVendor": "Baseline spend vendor",
          "proposedVendor": "Proposed vendor",
          "deleteTooltip": "You can delete this vendor as it was created in this audit. It will disappear from main vendors list as well.",
          "deleteDialog": {
            "withApprovedSpendItems": {
              "title": "Deleting a vendor with approved spend items",
              "description": "You are about to delete a vendor that is assigned to approved spend items. The vendor will also disappear from the main vendor list. All affected items will be automatically reassigned to the baseline vendor and marked as not approved. Do you want to continue?"
            },
            "withoutApprovedSpendItems": {
              "title": "Deleting vendor",
              "description": "You are about to delete a vendor. The vendor will also disappear from the main vendor list. All affected spend items will be automatically reassigned to the baseline vendor. Do you want to continue?"
            }
          },
          "delete": {
            "success": "Vendor deleted successfully",
            "error": "Failed to delete vendor. Please try again."
          },
          "actions": {
            "attachToAudit": "Attach to audit"
          },
          "fields": {
            "baselineSpend": "Baseline spend",
            "proposedSpend": "Proposed spend",
            "savingsIdentified": "Savings identified",
            "approvedSpendItems": "No of approved spend items",
            "savingsPercentage": "({{percentage}}%)",
            "approvedSpendItemsValue": "{{approved}} / {{total}}"
          },
          "detachDialog": {
            "withApprovedSpendItems": {
              "title": "Detaching a vendor with approved spend items from the audit",
              "description": "You are about to detach a vendor that is assigned to approved spend items. All affected items will be automatically reassigned to the baseline vendor (or to the newly attached vendor, if provided) and marked as not approved. Do you want to continue?"
            },
            "withoutApprovedSpendItems": {
              "title": "Detaching a proposed vendor from the audit",
              "description": "You are about to detach a vendor that is assigned to all spend items. These spend items will be automatically reassigned to the baseline vendor (or to the newly attached vendor, if one is provided later). Do you want to continue?"
            }
          },
          "attachDialog": {
            "withApprovedSpendItems": {
              "title": "Attaching a new vendor will automatically assign it to all items and mark them as “Not Approved”",
              "description": "Some spend items have already been approved. Attaching a new vendor will automatically reassign these items to the new vendor, and they will no longer be marked as approved. Please make sure to approve them again."
            }
          }
        },
        "vendorsRepository": {
          "title": "SIB Vendor List",
          "informationMessage": "Select and assign an existing vendor to the audit. You can attach vendors assigned to the audit's spend category. To use a new vendor, first create it in the Organization with an account number and locations.",
          "tempOpenButton": "Open SIB Vendor List (temp)",
          "actions": {
            "attachToAudit": {
              "label": "Attach to audit",
              "ariaLabel": "Attach vendor to audit"
            },
            "detachFromAudit": {
              "label": "Detach from audit",
              "ariaLabel": "Detach vendor from this audit",
              "tooltip": "Detach vendor from this audit"
            },
            "displayVendorsAssignedToOtherCategories": "Display vendors assigned to other categories",
            "attachedCount_one": "{{count}} vendor attached to this audit",
            "attachedCount_other": "{{count}} vendors attached to this audit",
            "attachedIndicator": {
              "ariaLabel": "Vendor attached to this audit",
              "tooltip": "Vendor attached to this audit"
            },
            "attach": {
              "success_one": "Vendor attached to audit successfully",
              "success_other": "{{count}} vendors attached to audit successfully",
              "error": "Failed to attach vendor(s) to audit. Please try again."
            },
            "detach": {
              "success_one": "Vendor detached from audit successfully",
              "success_other": "{{count}} vendors detached from audit successfully",
              "error": "Failed to detach vendor(s) from audit. Please try again."
            },
            "tooltips": {
              "bulkAttachDisabledAlreadyAttached": "One or more selected vendors are already attached to this audit.",
              "bulkDetachDisabledNotAttached": "One or more selected vendors are not attached to this audit."
            }
          },
          "table": {
            "columns": {
              "vendorName": "Vendor Name",
              "category": "Category",
              "spendAreas": "Spend Areas",
              "contracts": "Contracts",
              "clients": "Clients",
              "audits": "Audits",
              "openTickets": "Open tickets"
            },
            "selectVendor": "Select vendor",
            "categoryOverflowTriggerAriaLabel": "Show {{count}} more categories",
            "spendAreasOverflowTriggerAriaLabel": "Show {{count}} more spend areas"
          },
          "noData": {
            "title": "No vendors found",
            "description": "No vendors match the current filters."
          }
        },
        "spendItems": {
          "title": "Negotiate spend items",
          "description": "Set a new proposed spend for the selected items, choose a vendor, and approve them. If you do not approve the items before moving to the next stage, they will be marked as Spend Rejected. Items approved without a proposed spend value will be treated as having 0% savings.",
          "displayNotApprovedOnly": "Display not approved spend only",
          "approveTooltip": "Approve the items after you have finished negotiating with both the vendor and the client. Any items not approved before moving to the next stage will be marked as \"Spend Rejected\". Items approved without a proposed spend value will be treated as having 0% savings.",
          "pricePerUnitApprovedTooltip": "You cannot edit the price per unit on approved items. Revoke approval first to make changes.",
          "quantityApprovedTooltip": "You cannot edit the quantity on approved items. Revoke approval first to make changes.",
          "unitApprovedTooltip": "You cannot edit the unit on approved items. Revoke approval first to make changes.",
          "percentageRateApprovedTooltip": "You cannot edit the percentage rate on approved items. Revoke approval first to make changes.",
          "quantityNotApplicableTooltip": "Quantity does not apply to a percentage fee spend.",
          "unitNotApplicableTooltip": "Unit does not apply to a percentage fee spend.",
          "approve": {
            "success": "Spend item approved",
            "revoked": "Spend item approval revoked"
          },
          "pricePerUnit": {
            "success": "Price per unit updated"
          },
          "quantity": {
            "success": "Quantity updated"
          },
          "unit": {
            "success": "Unit updated"
          },
          "percentageRate": {
            "success": "Percentage rate updated"
          },
          "bulkApprove": {
            "success_one": "Spend item approved successfully",
            "success_other": "{{count}} spend items approved successfully"
          },
          "columns": {
            "itemId": "Item ID",
            "itemName": "Item name",
            "model": "Model",
            "baseline": "Baseline",
            "proposed": "Proposed",
            "quantity": "Qty",
            "unit": "Unit",
            "costPerItem": "Cost / item",
            "spend": "Spend",
            "savingsIdentified": "Savings identified",
            "frequency": "Frequency",
            "type": "Type",
            "proposedVendor": "Proposed vendor"
          },
          "emptyState": {
            "title": "No spend items",
            "description": "There are no spend items to negotiate yet."
          }
        },
        "client": {
          "spendItems": {
            "title": "Approve spend items",
            "description": "Below are all the spend items that were approved by the vendor in the previous stage. If you need to edit a specific item, you can go back to the previous stage. Mark the spend item as \"Approved\" once the client accepts it.",
            "setStatus": "Set status",
            "setStatusSuccess": "Status updated successfully",
            "setStatusDialog": {
              "title": "Set status",
              "description": "Set status for selected items ({{selected}}/{{total}}) to:",
              "approvedBanner": "{{approvedCount}} of {{total}} selected items are already approved and won't be changed. You can only change the status of spend items that are not yet approved.",
              "success_one": "Status updated for spend item successfully",
              "success_other": "Status updated for {{count}} spend items successfully"
            },
            "bulkApproveDialog": {
              "title_one": "Approve Spend Item",
              "title_other": "Approve Spend Items",
              "descriptionAllAccepted_one": "Do you want to approve this spend item?",
              "descriptionAllAccepted_other": "Do you want to approve these {{count}} spend items?",
              "descriptionNonAccepted_one": "One of the spend items you want to approve ({{count}}/{{selected}}) has a status other than 'Accepted.' After confirmation, its status will be automatically changed to 'Accepted.' Do you want to continue?",
              "descriptionNonAccepted_other": "Some of the spend items you want to approve ({{count}}/{{selected}}) have a status other than 'Accepted.' After confirmation, their status will be automatically changed to 'Accepted.' Do you want to continue?"
            },
            "columns": {
              "status": "Status",
              "type": "Type"
            },
            "status": {
              "meeting_scheduled": "Meeting scheduled",
              "in_review": "In review",
              "rejected": "Rejected",
              "accepted": "Accepted"
            }
          },
          "meetings": {
            "title": "Scheduled meetings",
            "description": "Schedule a meeting with your client to see if they agree with the new spend item values proposed by SIB and the vendor. You can also view previous meetings that have already taken place.",
            "addNew": "Add new",
            "upcoming": "Upcoming meetings",
            "past": "Past meetings",
            "emptyUpcoming": "No upcoming meetings scheduled yet.",
            "emptyPast": "No past meetings yet.",
            "form": {
              "addTitle": "Add new meeting",
              "editTitle": "Edit meeting",
              "viewTitle": "Meeting details",
              "editInfoBanner": "Please note that all changes (besides internal notes) regarding this meeting will also update the corresponding action item in the client's SpendBrain",
              "nameLabel": "Meeting name / subject",
              "assigneeLabel": "SIB assignee",
              "dateLabel": "Date",
              "meetingUrlLabel": "Meeting URL",
              "meetingUrlPlaceholder": "https://www.outlookmeetings.com/123",
              "meetingUrlCaption": "Paste the URL of the platform where your online meeting with the client will take place",
              "contactLabel": "Client's point of contact",
              "contactPlaceholder": "Select a contact",
              "contactEmptyState": {
                "title": "There are no contacts for this client yet.",
                "description": "Add a contact for this client to select them as the point of contact."
              },
              "displayActionItemLabel": "Display as an action item in the client's SpendBrain",
              "displayActionItemTooltip": {
                "locked": "This meeting has already been displayed as an action item in the client’s SpendBrain. This setting cannot be changed.",
                "create": "Once you create a meeting and mark it as displayed for the client, this setting cannot be changed"
              },
              "notes": {
                "title": "Internal notes",
                "caption": "Add any important notes for your colleagues. These notes are visible only to SIB employees and will be displayed below.",
                "addButton": "Add note",
                "deleteLabel": "Delete note",
                "deleteDisabledTooltip": "You cannot delete this note because it was not created by you",
                "deleteDialog": {
                  "title": "Deleting note",
                  "description": "Are you sure you want to delete this note?"
                }
              },
              "save": "Save",
              "createSuccess": "Meeting scheduled successfully",
              "updateSuccess": "Meeting updated successfully"
            },
            "row": {
              "attendee": "Attendee",
              "date": "Date",
              "notes": "Notes",
              "viewInCalendarLabel": "View in calendar",
              "viewInCalendarDisabledTooltip": "Add a meeting URL to enable this",
              "editLabel": "Edit meeting",
              "viewLabel": "View meeting",
              "deleteLabel": "Delete meeting",
              "deleteDisabledTooltip": "You cannot delete this meeting because it was not created by you",
              "expandDetails": "Show meeting details",
              "collapseDetails": "Hide meeting details",
              "deleteDialog": {
                "title": "Deleting meeting",
                "description": "Are you sure you want to delete this meeting?",
                "descriptionActionItem": "Are you sure you want to delete this meeting? It has already been created as an action item in your client's SpendBrain. The client will be immediately notified that the meeting has been canceled.",
                "displayedAsActionItem": "Displayed as an action item in the client's SpendBrain",
                "confirm": "Delete"
              }
            }
          }
        }
      }
    }
  }
}
